import Cookies from 'js-cookie';
import _ from 'lodash';

export default function($el) {
  function utmCookie() {
    return Cookies.get('maji_utm');
  }

  function parsedQueryString() {
    return queryString.parse(window.location.search);
  }

  function utmParams() {
    return _.pickBy(parsedQueryString(), (value, key) => _.startsWith(key, 'utm_'));
  }

  function setUtmCookie() {
    Cookies.set('maji_utm', utmParams(), { expires: 30, domain: $el.data('domain') });
  }

  function setPermanentEmailModalCookie() {
    const permanentYears = 20;
    Cookies.set('_maji_hide_email_capture_modal', true, {expires: permanentYears * 365, domain: $el.data('domain') });
  }

  function setThirtyDayEmailModalCookie() {
    Cookies.set('_maji_hide_email_capture_modal', true, {expires: 30, domain: $el.data('domain') });
  }

  if (utmParams().utm_medium === 'email') setPermanentEmailModalCookie();
  if (parsedQueryString().email_capture_modal === 'none') setThirtyDayEmailModalCookie();

  if (utmCookie() !== undefined || _.isEmpty(utmParams())) {
    return false;
  } else {
    setUtmCookie();
  }
}
